<div class="footer-container">
    <div class="main-footer-content">
        <ng-container *ngIf="contactInfo">
            <div class="footer-left">
                <div class="link-header">Contact Us</div>
                <ul class="contactLinks">
                    <li>{{contactOptions?.address1}}</li>
                    <li>{{contactOptions?.address2}}</li>
                    <li>{{contactOptions?.address3}}</li>
                    <li>{{contactOptions?.city}}</li>
                </ul>
            </div>
        </ng-container>
        <ng-container *ngIf="infoLinks">
            <div class="footer-center">
                <div class="link-header">Useful Information</div>
                <ul [ngSwitch]="type" class="infolinks">
                    <li *ngFor="let item of infoOptions | keyvalue" [ngSwitch]="item.key">
                        <span *ngSwitchCase="'aboutUsLink'">About Us</span>
                        <span *ngSwitchCase="'blogLink'">Blog</span>
                        <span *ngSwitchCase="'policiesLink'">Policies</span>
                        <span *ngSwitchCase="'newsLetterSignUpLink'">Newsletter</span>
                    </li>
                </ul>
            </div>
        </ng-container>
        <ng-container *ngIf="socialMediaLinks">
            <div class="footer-right">
                <div class="link-header">Follow Us</div>
                <ul [ngSwitch]="type" class="sociallinks">
                    <li *ngFor="let item of socialMediaOptions | keyvalue" [ngSwitch]="item.key">
                        <span *ngSwitchCase="'faceBookLink'"><i _ngcontent-qeb-c317="" class="fab fa-facebook fa-2x"></i></span>
                        <span *ngSwitchCase="'twitterLink'"><i class="fab fa-twitter fa-2x" aria-hidden="true"></i></span>
                    </li>
                </ul>
            </div>
        </ng-container>    
            
    </div>
    <div class="powered-by">
        Powered By Kwikstore &copy; <span #datetime></span>
    </div>
</div>
<!-- <div class="footer-container">
    <div class="main-footer-content">
        <ng-container *ngIf="contactInfo">
            <div class="footer-left">
                <p>Contact Links Go here</p>
            </div>
        </ng-container>
        <ng-container *ngIf="infoLinks">
            <div class="footer-center">
                <p>Info Links go here</p>
            </div>
        </ng-container>
        <ng-container *ngIf="socialMediaLinks">
            <div class="footer-right">
                <p>Social Media Links go here</p>
            </div>
        </ng-container>
    </div>
    <div class="powered-by">
        Powered By Kwikstore &copy; <span #datetime></span>
    </div>
</div> -->

